import apiInstance from "../api";

export const getThemeInfo = () => {
  return apiInstance().get(
    `/theme/?fields=theme_id,name,created_time,updated_time`
  );
};
